export const STORAGE_KEY_SETTINGS_LANGUAGE = "settings/language";

export const supportedLanguages = ["en", "vi"];
